import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { TradableWallet as OldTradableWallet } from "@models/interfaces/tradable_wallet";

export interface TradableWalletBase {
	readonly guid: string;
	readonly isDefault: boolean;
	readonly isDeleted: boolean;
	readonly cryptoCoinId: number;
	readonly balance: number;
	readonly name: string;
	readonly pendingTransactionsCount: number;
	readonly isNewWallet: boolean; // TODO temp (until dummy wallets will be removed)
}

export class TradableBaseWalletAdapter extends BaseAdapter<OldTradableWallet, TradableWalletBase> {
	public adapt(item: OldTradableWallet): TradableWalletBase {
		if (!item) {
			return null;
		}

		return {
			guid: item.getId(),
			isDefault: item.isDefault(),
			isDeleted: item.isDeleted(),
			cryptoCoinId: Number(item.getCurrencyId()),
			balance: item.getBalance(),
			name: item.getName(),
			pendingTransactionsCount: item.getPendingTransactionCount(),
			isNewWallet: item.isNew()
		};
	}
}
